/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */

import { Component, ViewChild } from '@angular/core';
import { GtinValidationSetService } from 'app/services/gtin-validation-set.service';
import { GtinValidationSetDetail } from "app/models/gtin-validation-set-detail";
import { PagedResults } from "app/models/paged-results";
import { RESULTS_PER_PAGE } from "app/app-constants";
import { ConfirmDeleteDialogComponent } from "../confirm-delete-dialog.component";
import { EditViewGtinValidationSetDialogComponent } from "./edit-view-gtin-validation-set.dialog.component";
/** Declare $ to call bootstrap */
declare var $: any;


@Component({
    selector: 'app-view-gtin-dialog',
    templateUrl: './view-gtin-validation-set.dialog.component.html',
    styleUrls: ['../../../assets/css/infrastructure.css']
})
export class ViewGtinValidationSetDialogComponent {

    /** GTIN Validation Sets being displayed in the UI */
    gtinDetails: GtinValidationSetDetail[] = [];

    @ViewChild('confirmDeleteDialog')
    confirmDialog: ConfirmDeleteDialogComponent;

    /** Dialog used to view GTIN14 and percentages*/
  @ViewChild('editViewGtinDialog', { static: false })
  mEditViewGtinDialogComponent: EditViewGtinValidationSetDialogComponent;

    /* Paging Variables */
    numberOfViewGtin = 0;
    totalNumberOfViewGtin = 0;
    currentPageForViewGtin = 1;
    resultsPerPageValues = RESULTS_PER_PAGE;
    selectedPageSizeValueForViewGtin: number = this.resultsPerPageValues[0];

    /* Filter Variables */
    filterColumnViewGtin = null;
    filterColumnNameViewGtin = "";
    filterStringViewGtin = "";

    /** Holds the name of the GTIN Set being viewed */
    name = "";
    dtlsId = null;	
    showConfirm =  true;
    /** Constructor */
    constructor(
        private gtinService: GtinValidationSetService
    ) { }

    

    /**
   * Reset's the UI and displays the Dialog
   */
    public show(name: string): void {
        // Reset the UI
        this.reset();

        this.name = name;
        this.refreshGtinDetail();
        $("#viewGtinDialog").modal("show");

    }

    /**
     * Hides the Dialog
     */
    public hide(): void {
        $("#viewGtinDialog").modal("hide");
    }

    /**
     * Called when the "Cancel" UI Button is clicked.
     * Cancels / Hides the Dialog.
    */
    onCancelClicked(): void {
        this.hide();
    }
    /**
   * Reset's the UI Elements back to the defaults
   */
    private reset(): void {
        this.name = "";
        this.setFilterViewGtinValidationSet(null, null);

        // Clear the Details
        while (this.gtinDetails.length > 0) {
            this.gtinDetails.pop();
        }
        this.totalNumberOfViewGtin = 0;
    }

    public async refreshGtinDetail(): Promise<void> {
        // Clear the current list
        while (this.gtinDetails.length > 0) {
            this.gtinDetails.pop();
        }
        this.totalNumberOfViewGtin = 0;

        // If no name is specified, then there are no details...
        if (this.name == null || this.name.trim().length == 0) {
            return;
        } else {
            // Make the API call
            let page: PagedResults<GtinValidationSetDetail> = null;
            try {
                page = await this.gtinService.getGtinValidationSetdetails((this.currentPageForViewGtin - 1) * this.selectedPageSizeValueForViewGtin, this.selectedPageSizeValueForViewGtin, 'ASC', this.filterColumnViewGtin, this.filterStringViewGtin, this.name);
            } catch (error) {
                this.handleError(error);
                return;
            }

            // Add the data for the current list
            if (page.data?.length > 0) {
                this.gtinDetails.push(...page.data);
            }

            // Update the total size for paging
            this.totalNumberOfViewGtin = page.size;
            return;
        }
    }

    /**
     * Displays the error to the User
     */
    handleError(error: any): void {
        /* New handling (TJB 04/18/2023) */
        if (error?.error != null) {
            alert(error.error);
        }

        /* Default back to old handling */
        else if (error != null) {
            const response: Response = error;
            alert(response.text());
        }
    }

    setFilterViewGtinValidationSet(filterColumnName: string, filterColumn: string): void {
        this.filterColumnViewGtin = filterColumn;
        this.filterColumnNameViewGtin = filterColumnName;
        if (!this.filterColumnViewGtin) {
            this.filterStringViewGtin = "";
        }
        this.filterStringChangedViewGtin(1);
    }

    filterStringChangedViewGtin(pageNumber?: number): void {
        if (!pageNumber) { pageNumber = 1; }
        // Show only size on this new page
        this.currentPageForViewGtin = pageNumber;

        this.refreshGtinDetail();
    }

    pageChanged(pageNumber: number): void {
        if (pageNumber == null || pageNumber == undefined || pageNumber < 1) {
            return;
        }
        if (this.currentPageForViewGtin == pageNumber) {
            return;
        }
        this.currentPageForViewGtin = pageNumber;
        this.refreshGtinDetail();
    }

  /**
   * Called when the User changes the "Results Per Page" value.
   * Refreshes the GTIN Headers being displayed to include the new page size.
   */
  updateResultsPerPageValue(value: number): void {
    this.selectedPageSizeValueForViewGtin = value;

    // Selecting any value will bring you back to first page
    this.currentPageForViewGtin = 1;
    this.refreshGtinDetail();
    }
    // ---------------- CRUD Actions ----------------
    addClicked(): void {
         const editgtinDetails: GtinValidationSetDetail = new GtinValidationSetDetail();
        this.mEditViewGtinDialogComponent.show(editgtinDetails,this.name);
    }

    editRowClicked(gtinDetails: GtinValidationSetDetail): void {
        this.mEditViewGtinDialogComponent.show(gtinDetails,this.name);
    }

    deleteRowClicked(gtinDetails: GtinValidationSetDetail): void {
        this.dtlsId = gtinDetails.id;
        this.confirmDialog.show("Delete Validation Sets", [gtinDetails.gtin14]);
    }

    // Listen to confirm event
    onConfirmDelete(): void {
        this.deleteGtinValidationPercent();
        this.showConfirm = false;
        
    }

    deleteGtinValidationPercent(): void {
        //const selectedIds = this.getSelectedGtinIds();
        this.gtinService.deleteValidationDetailSets(this.dtlsId).then(
            () => {

                this.showConfirm = true;
                this.refreshGtinDetail();
            },
            error => {
                this.handleError(error);
            }
        );

    }

}